var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid set-new-password-page" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("LayoutLeftAuth"),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5" }, [
          _c(
            "div",
            {
              staticClass:
                "container h-full d-flex align-items-center justify-content-center"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "row d-flex flex-column text-center align-items-center"
                },
                [
                  _c("img", {
                    staticClass: "logo-mobile-auth d-block d-sm-none",
                    attrs: { src: require("../../assets/img/blue-logo.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "reset-title" }, [
                    _vm._v("Reset your password")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "reset-undertitle" }, [
                    _vm._v("Create a new password for your account")
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "new-auth-form",
                      attrs: { autocomplete: "no" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.send($event)
                        },
                        keydown: function($event) {
                          _vm.clearError($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-row d-flex justify-content-center align-items-center"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 col-lg-12 mb-16" },
                            [
                              _c("div", { staticClass: "material-textfield" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.password,
                                      expression: "user.password"
                                    }
                                  ],
                                  attrs: {
                                    id: "password",
                                    type: "password",
                                    name: "password",
                                    placeholder: " ",
                                    autofocus: ""
                                  },
                                  domProps: { value: _vm.user.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.user,
                                        "password",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Password")]),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "material-append passwordPopup",
                                  attrs: {
                                    src: require("../../assets/img/info-gray.svg"),
                                    width: "20"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _c("error-field", {
                                staticClass: "material-errors",
                                attrs: { errors: _vm.errors, field: "password" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-12 col-lg-12" },
                            [
                              _c("div", { staticClass: "material-textfield" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.user.password_confirmation,
                                      expression: "user.password_confirmation"
                                    }
                                  ],
                                  attrs: {
                                    id: "password_confirmation",
                                    name: "password_confirmation",
                                    type: "password",
                                    placeholder: " "
                                  },
                                  domProps: {
                                    value: _vm.user.password_confirmation
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.user,
                                        "password_confirmation",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Password confirmation")])
                              ]),
                              _vm._v(" "),
                              _c("error-field", {
                                staticClass: "material-errors",
                                attrs: {
                                  errors: _vm.errors,
                                  field: "password_confirmation"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("error-field", {
                        staticClass: "material-errors",
                        attrs: { errors: _vm.errors, field: "credentials" }
                      }),
                      _vm._v(" "),
                      _c("error-field", {
                        staticClass: "material-errors",
                        attrs: { errors: _vm.errors, field: "exception" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass:
                          "btn btn-primary login-button set-btn hover-btn-bg",
                        attrs: {
                          type: "submit",
                          value: "Set new password",
                          disabled: _vm.errors.any()
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { id: "passwordPopup" } },
      [
        _c("p", { staticClass: "popup-rules-title" }, [
          _vm._v("Password rules:")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "password-popup-list" }, [
          _c("p", [_vm._v("• 8 characters long")]),
          _vm._v(" "),
          _c("p", [_vm._v("• 1 uppercase letter")]),
          _vm._v(" "),
          _c("p", [_vm._v("• 1 lowercase letter")]),
          _vm._v(" "),
          _c("p", [_vm._v("• 1 number")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bee67c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bee67c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SetNewPassword.vue
// module id = null
// module chunks = 